import React from 'react';
import { Route } from 'react-router-dom';
import AboutUs from './screens/AboutUs/Loadable';
import Homepage from './screens/Homepage/Loadable';
import Loans from './screens/Loans/Loadable';
import Funding from './screens/Funding/Loadable';
import FAQ from './screens/FAQ/Loadable';
import PrivacyPolicy from './screens/PrivacyPolicy/Loadable';
import Terms from './screens/Terms/Loadable';
import 'styling/semantic.less'
import Footer from "./components/Footer";
import NavBar from "./components/NavBar/NavBar";
import Redirect from './screens/Redirect/Loadable';
import { Switch } from 'react-router-dom';

export default function App() {
    return (
        <NavBar>
            <Switch>
                <Route exact path="/" component={Homepage}/>
                <Route name="borrow" path="/borrow" component={Loans}/>
                <Route name="lend" path="/lend" component={Funding}/>
                <Route name="aboutUs" path="/aboutUs" component={AboutUs}/>
                <Route name="faq" path="/faq" component={FAQ}/>
                <Route name="privacyPolicy" path="/privacyPolicy" component={PrivacyPolicy}/>
                <Route name="terms" path="/terms" component={Terms}/>
                <Route name="redirect" path='/redirect' component={Redirect}/>
            </Switch>
            <Footer/>
        </NavBar>
    )
};


// WEBPACK FOOTER //
// ./src/App.js